<div class="kartlegging-header">
    <button (click)="visModal()">
        <hb-icon [iconId]="'remove'"/>
        <span>
                Avslutt
        </span>
    </button>
</div>

<hb-modal-bekreft
    [visModal$]="visModal$"
    tittel="Er du sikker på at du vil avslutte?"
    bekreftTekst="Avslutt"
    avbrytTekst="Fortsett kartleggingen"
    (bekreft)="avslutt()"
    (avbryt)="skjulModal()"
>
    <p class="hb-text--semibold">Svarene dine blir ikke lagret.</p>
    <p>Hvis du avslutter nå, må du starte på nytt neste gang.</p>
</hb-modal-bekreft>
